import type { ReactNode } from 'react';
import { PlansWorkspace } from '../components/evaluation/PlansWorkspace';

/**
 * ADMIN-03 (F19.03) — reusable interview plans, admin redesign batch 2 Option A: whole rounds, panel and shares included (S12
 * Q7). A job copies one with "Start from a plan" in its round setup; editing it here never changes a job (#4).
 */
export function PlanTemplatesPage(): ReactNode {
  return <PlansWorkspace selectedId={null} />;
}
